import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight, GraduationCap } from "lucide-react";

export default function Schemes() {
  const [schemes, setSchemes] = useState([]);
  useEffect(() => { api.get("/schemes").then(r => setSchemes(r.data.sort((a,b)=>a.code.localeCompare(b.code)))); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <div className="mb-12 max-w-3xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 mb-3">Skema Sertifikasi</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-emerald-950">7 Skema Kompetensi Realestat</h1>
        <p className="mt-4 text-slate-600">Pilihan skema sertifikasi kompetensi bidang perumahan, permukiman, investasi, pemasaran, penjualan, dan pengelolaan lingkungan.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {schemes.map(s => (
          <div key={s.id} data-testid={`scheme-${s.code}`} className="bg-white rounded-2xl p-7 border border-slate-100 hover:border-amber-300 hover:shadow-xl transition-all group">
            <div className="flex items-center justify-between mb-4">
              <div className="font-display text-5xl font-extrabold gold-gradient-text">{s.code}</div>
              <GraduationCap className="w-8 h-8 text-emerald-700/40" />
            </div>
            <h3 className="font-display font-bold text-lg text-emerald-950 leading-snug min-h-[3.5rem]">{s.title}</h3>
            <p className="text-sm text-slate-600 mt-3 line-clamp-2">{s.short_desc}</p>
            <div className="mt-6 flex gap-2">
              <Link to={`/skema/${s.id}`} data-testid={`scheme-detail-${s.code}`} className="flex-1 inline-flex items-center justify-center gap-1 py-2.5 rounded-lg border-2 border-emerald-950 text-emerald-950 text-sm font-bold hover:bg-emerald-950 hover:text-white transition-all">Lihat Detail</Link>
              <Link to={`/daftar?skema=${s.id}`} data-testid={`scheme-register-${s.code}`} className="flex-1 inline-flex items-center justify-center gap-1 py-2.5 rounded-lg gold-gradient text-emerald-950 text-sm font-bold">Daftar</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
